import { GenericAbortSignal } from 'axios';

import { Library } from '../types/Library';
import { Project, VideoInfo } from '../types/Project';
import { LIBRARY_API_URL } from './constants';
import { get } from './requestMethods';

export const LIBRARY_CALLS_API = {
  // Get media file status by ID
  getLinkedMediaUploadStatus: (mediaId: string, signal?: GenericAbortSignal) =>
    get<Library>(`${LIBRARY_API_URL}/media/${mediaId}`, { signal }),
  
  // Get video metadata when uploading videos from Youtube
  getVideoInfo: (data: { url: Project['source_url'] }, signal?: GenericAbortSignal) =>
    get<VideoInfo>(`${LIBRARY_API_URL}/info/video?link=${data.url}`, { signal }),
};
